import { Box, Button, Typography } from "@mui/material";
import React from "react";
import { dataSourceList } from "../utils/data";

const PrivacyPolicy = () => {
  const today = new Date();
  return (
    <Box className="bg-white flex-column  w-full rounded-[20px] border border-primary-blue-100">
      <Box className="flex-between-center gap-5 p-5 border-b border-b-primary-blue-100 ">
        <Typography className="!text-xl !font-medium">
          Trial Partners Privacy Policy
        </Typography>
      </Box>

      <Box className="py-6 px-5">
        <h1 className="font-medium text-lg"> Effective Date: {today.toDateString()}</h1>
        <br />

        <p className="font-base text-primary-black-800">
          Thank you for choosing Trial Partner. This Privacy Policy outlines how
          we collect, use, share, and protect your personal information when you
          use our Ad Analytics Web Platform. Please read this policy carefully
          to understand our practices.
        </p>
        <br />
        <h2 className="font-medium">1. Information We Collect</h2>
        <br />

        <p className="font-base text-primary-black-800">
          We collect various types of information to provide, maintain, and
          improve our platform:
        </p>
        <ul className="ml-5">
          <li className="font-base text-primary-black-800">
            User Data: Name, email address, company name, and login credentials.
          </li>
          <li className="font-base text-primary-black-800">
            Ad Analytics Data: Information related to ad spend, ad creatives, ad
            copy, and performance metrics across various ad platforms.
          </li>
          <li className="font-base text-primary-black-800">
            Platform Usage Data: Information about your interactions with the
            platform, including the pages you visit, features you use, and
            actions you take.
          </li>
          <li className="font-base text-primary-black-800">
            Patient/Customer Data: Anonymized data regarding users (patients)
            who engage with your ads, such as demographics, behaviors, and
            platform referral details.
          </li>
        </ul>
        <br />

        <h2 className="font-medium">2. How We Use Your Information</h2>
        <br />

        <p className="font-base text-primary-black-800">
          The data we collect is used for the following purposes:
        </p>
        <ul className="ml-5">
          <li className="font-base text-primary-black-800">
            Providing and improving our platform and services.
          </li>
          <li className="font-base text-primary-black-800">
            Tracking and analyzing ad performance, including ad spend and user
            engagement.
          </li>
          <li className="font-base text-primary-black-800">
            Offering insights and analytics on ad creatives, targeting
            strategies, and user behaviors.
          </li>
          <li className="font-base text-primary-black-800">
            Identifying the platforms and ads that lead users (patients) to your
            services.
          </li>
          <li className="font-base text-primary-black-800">
            Communicating with you about platform updates, new features, and
            support.
          </li>
        </ul>
        <br />

        <h2 className="font-medium">3. Data Sharing and Disclosure</h2>
        <br />

        <p className="font-base text-primary-black-800">
          We do not sell your personal information. However, we may share your
          information under the following circumstances:
        </p>
        <ul className="ml-5">
          <li className="font-base text-primary-black-800">
            Service Providers: With trusted third-party service providers that
            assist in operating the platform, such as data analytics and hosting
            services.
          </li>
          <li className="font-base text-primary-black-800">
            Legal Compliance: If required by law, to comply with a legal
            obligation or in response to a legal process.
          </li>
          <li className="font-base text-primary-black-800">
            Business Transfers: In connection with a merger, acquisition, or
            sale of our company, we may transfer your information to the
            acquiring party.
          </li>
        </ul>
        <br />

        <h2 className="font-medium">4. Data Security</h2>
        <br />

        <p className="font-base text-primary-black-800">
          We take reasonable measures to protect your information from
          unauthorized access, disclosure, or alteration. Our platform uses
          encryption and secure protocols to ensure the safe transmission and
          storage of data.
        </p>
        <br />

        <h2 className="font-medium">5. Cookies and Tracking Technologies</h2>
        <br />

        <p className="font-base text-primary-black-800">
          We use cookies and similar technologies to track your usage of the
          platform, enhance user experience, and analyze platform performance.
          You can control cookie settings through your browser, but disabling
          cookies may affect your experience on the platform.
        </p>
        <br />

        <h2 className="font-medium">
          6. Your Data Rights You have the right to :
        </h2>
        <br />

        <ul className="ml-5">
          <li className="font-base text-primary-black-800">
            Access the personal information we hold about you.
          </li>
          <li className="font-base text-primary-black-800">
            Request corrections to inaccurate or incomplete data.
          </li>
          <li className="font-base text-primary-black-800">
            Request the deletion of your personal information, subject to legal
            obligations.
          </li>
          <li className="font-base text-primary-black-800">
            Opt-out of certain data collection and communications.
          </li>
        </ul>
        <br />

        <h2 className="font-medium">7. Changes to This Privacy Policy</h2>
        <br />

        <p className="font-base text-primary-black-800">
          We may update this Privacy Policy from time to time. Any changes will
          be posted on this page with an updated effective date. We encourage
          you to review this policy periodically.
        </p>
        <br />

        <h2 className="font-medium">8. Contact Us</h2>
        <br />

        <p className="font-base text-primary-black-800">
          If you have any questions or concerns about this Privacy Policy or our
          data practices, please contact us at:
        </p>
        <ul className="ml-5">
          <li className="font-base text-primary-black-800">
            Email: [Insert Contact Email]
          </li>
          <li className="font-base text-primary-black-800">
            Address: [Insert Contact Address]
          </li>
        </ul>
      </Box>
    </Box>
  );
};

export default PrivacyPolicy;
